module.exports = __webpack_public_path__ + "700e0368ca84e71a6ac5d6b78dc6f6a7.jpg";